module.exports = __webpack_public_path__ + "img/seta_empresas.3ffe500e.png";